export enum SessionStatus{
    ACTIVE = 1,
    END = 8,
    UPCOMING = 9,
    DELETE = 0
}